import { useContext } from "react";
import { AppContext } from "../App";
import fullLogo from "../assets/full_logo.png";
import featureImage from "../assets/window_cleaning.jpg";
import Backdrop from "./Backdrop";
import { MdClose } from "react-icons/md";
import { FaArrowRight, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import { COMPANY_EMAIL, COMPANY_PHONE, navItems } from "../siteData";

export default function SideBar() {
  const appContext = useContext(AppContext);

  function goTo(item) {
    appContext.navTo({ item });
    appContext.setIsSideBarOpen(false);
  }

  return (
    <>
      <Backdrop
        style={{
          visibility: appContext.isSideBarOpen ? "visible" : "hidden",
          opacity: appContext.isSideBarOpen ? "1" : "0",
          zIndex: "9998",
          pointerEvents: appContext.isSideBarOpen ? "auto" : "none",
        }}
      />

      <aside className="SideBar" data-open={appContext.isSideBarOpen}>
        <div className="sidebar-mobile-shell">
          <div className="sidebar-mobile-header">
            <button
              className="sidebar-mobile-brand"
              onClick={() => goTo("home")}
              aria-label="Go to home page"
            >
              <img src={fullLogo} alt="MS Universal Distributors" />
            </button>

            <button
              className="sidebar-close-btn"
              onClick={() => appContext.setIsSideBarOpen(false)}
              aria-label="Close mobile menu"
            >
              <MdClose size={28} />
            </button>
          </div>

          <div className="sidebar-mobile-content">
            <div className="sidebar-mobile-main">
              {navItems.map((nav, index) => (
                <button
                  key={nav.item}
                  className="sidebar-mobile-link"
                  data-active={
                    nav.item === "home"
                      ? !appContext.navItem || appContext.navItem === "home"
                      : appContext.navItem === nav.item
                  }
                  onClick={() => goTo(nav.item)}
                >
                  <span>{nav.label}</span>
                  <FaArrowRight />
                </button>
              ))}
            </div>

            <div className="sidebar-mobile-feature">
              <img
                src={featureImage}
                alt="MS Universal cleaning and supply services"
                className="sidebar-mobile-feature-image"
              />
              <div className="sidebar-mobile-feature-card">
                <h4>Supply, cleaning, delivery, and dependable service under one brand.</h4>
                <p>
                  We support homes, offices, institutions, and commercial clients
                  with quality goods and timely service.
                </p>
                <div className="sidebar-mobile-contact-list">
                  <a href="tel:+255658902790">
                    <FaPhoneAlt />
                    <span>{COMPANY_PHONE}</span>
                  </a>
                  <a href={`mailto:${COMPANY_EMAIL}`}>
                    <FaEnvelope />
                    <span>{COMPANY_EMAIL}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
}
